import { initialState } from "reducers/DeliveryStatusDashboard/State";
import { DeliveryStatusDashboard } from "constants/Actions";
import { formatStatusDetails } from "functions"

const {
  GET_DELIVERY_STATUS_LIST,
  GET_DELIVERY_STATUS_LIST_SUCCESS,
  GET_DELIVERY_STATUS_LIST_FAIL,

  GET_DASHBOARD_STATUS_DETAILS,
  GET_DASHBOARD_STATUS_DETAILS_SUCCESS,
  GET_DASHBOARD_STATUS_DETAILS_FAIL,
} = DeliveryStatusDashboard;

export default (state = initialState, { payload, type }: any) => {
  switch (type) {
    case GET_DELIVERY_STATUS_LIST:
      return Object.assign({}, state, {
        deliveryStatusList: {
          data: [],
          isLoading: true,
        },
      });
    case GET_DELIVERY_STATUS_LIST_SUCCESS:
      return Object.assign({}, state, {
        deliveryStatusList: {
          data: payload.data,
          isLoading: false,
        },
      });
    case GET_DELIVERY_STATUS_LIST_FAIL:
      return Object.assign({}, state, {
        deliveryStatusList: {
          ...state.deliveryStatusList,
          isLoading: false,
        },
      });
    case GET_DASHBOARD_STATUS_DETAILS:
      return Object.assign({}, state, {
        deliveryStatusDetails: {
          data: [],
          isLoading: true,
        },
      });
    case GET_DASHBOARD_STATUS_DETAILS_SUCCESS:
      return Object.assign({}, state, {
        deliveryStatusDetails: {
          data: formatStatusDetails(payload.data),
          isLoading: false,
        },
      });
    case GET_DASHBOARD_STATUS_DETAILS_FAIL:
      return Object.assign({}, state, {
        deliveryStatusDetails: {
          ...state.deliveryStatusDetails,
          isLoading: false,
        },
      });
    default:
      return state;
  }
};
